import { ActionButton } from "../buttons/ActionButton";
import { Modal } from "./Modal";


export const ConfirmModal = ({ isOpen, setIsOpen, title="Confirmer ?", text="Confirmez-vous l'action ?", onConfirm }) => {

  const onConfirmClick = () => {
    onConfirm?.();
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size="medium">
      <h3 className="mb-4 text-lg font-medium">{title}</h3>
      <div>
        <p className="mb-4">{text}</p>
        <div className="flex justify-end gap-2 mt-8">
          <ActionButton text="Annuler" color="cancel" onClick={() => setIsOpen(false)}/>
          <ActionButton text="Confirmer" color="danger" onClick={onConfirmClick}/>
        </div>
      </div>
    </Modal>
  );
};